import { getKeyByValue } from './generalHelpers';
export const PropertyStatuses = {
    NONE: 'None',
    LEAD: 'Lead',
    NOT_FEASIBLE: 'Not Feasible',
    OPPORTUNITY: 'Opportunity',
    DETAILED_FEASIBILITY: 'Detailed Feasibility',
    OFFER_REJECTED: 'Offer Rejected',
    OFFER_ACCEPTED: 'Offer Accepted',
    TITLE_RECORDED: 'Title Recorded',
    MISSED_OPPORTUNITY: 'Missed Opportunity',
    PERMIT_ISSUED: 'Permit Issued',
    UNDER_CONSTRUCTION: 'Under Construction',
    ON_MARKET: 'On Market',
    SALE_ACCEPTED: 'Sale Accepted',
    UNDER_WARRANTY: 'Under Warranty',
};

export const ProjectStatuses = {
    AWAITING_PERMIT: 'Awaiting Permit',
    PERMIT_ISSUED: 'Permit Issued',
    HORIZONTAL_CONSTRUCTION: 'Horizontal Construction',
    VERTICAL_CONSTRUCTION: 'Vertical Construction',
    ON_MARKET: 'On Market',
    SALE_ACCEPTED: 'Sale Accepted',
    UNDER_WARRANTY: 'Under Warranty',
    OUT_OF_WARRANTY: 'Out of Warranty',
    DIVESTED: 'Divested',
};

export function transformResponseToPropsByStatus(
    response,
    statuses,
    dict,
    fieldname,
    idFieldname
) {
    const properties = response.records;
    const propsByStatus = {};
    statuses.forEach((s) => {
        const keyValue = getKeyByValue(dict, s);
        propsByStatus[keyValue] = [];
    });

    for (let status in propsByStatus) {
        const props = properties
            .filter((prop) => prop[fieldname] == Number(status))
            .map((prop) => ({ kanbanId: prop[idFieldname], ...prop }));
        propsByStatus[status] = props;
    }
    return propsByStatus;
}
